<template lang="pug">
  f7-button(
    big
    fill
    :disabled="disabled"
    @click="$emit('click', $event)"
  ) {{ title }}
</template>

<style lang="scss" scoped>
#framework7-root .button {
  @extend %button;
  @extend %multiline-button-text;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 20px;
  margin-left: 24px;
  margin-right: 24px;
  background: $btn-primary;
  -webkit-tap-highlight-color: $btn-primary-hover;
  white-space: pre-wrap;

  &.disabled {
    background: $btn-primary-disabled;
  }
}
</style>

<script>
export default {
  props: {
    title: { type: String, required: true },
    disabled: { type: Boolean, required: false },
  },
}
</script>
